import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import Menu from "../Menu";

const TransmissionShares: React.FC = () => {
  const contentContainerRef = useRef<HTMLDivElement | null>(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (contentContainerRef.current) {
        const contentRect = contentContainerRef.current.getBoundingClientRect();
        setIsSticky(contentRect.top <= 0);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div ref={contentContainerRef}>
      {/* Static Banner Section */}
      <Box
        sx={{
          width: "100%",
          height: "50vh",
          position: "relative",
          overflow: "hidden",
          background: `
            linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)),
            url(${"/assets/service_01.jpg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Menu isSticky={isSticky} />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#fff",
            textAlign: "center",
          }}
        >
          <Typography variant="h3" fontWeight="bold" letterSpacing={1}>
            Transmission of Shares
          </Typography>
        </Box>
      </Box>
  
      {/* Sections Below */}
      <Box sx={{ padding: "20px", backgroundColor: "#f9f9f9", color: "#000" }}>
        <Box
          sx={{
            padding: "20px",
            margin: "20px auto",
            maxWidth: "800px",
          }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Transmission of Shares on Death of a Shareholder
          </Typography>
  
          <Typography variant="body1" paragraph>
            The process of transferring the shares of a deceased person to their legal heir is known as <strong>transmission of shares</strong>. The procedure depends on whether the deceased had a <strong>Nominee</strong>, a <strong>Will/Probate</strong>, or passed away <strong>without a will or nominee</strong>.
          </Typography>
  
          {/* Nominee Section */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
          When a Nominee is Registered
          </Typography>
          <Typography variant="body1" paragraph>
            If the deceased had registered a nominee, the shares are transmitted to the nominee by executing an <strong>Indemnity-cum-Affidavit</strong> and submitting it to the company or Registrar and Transfer Agent (RTA). The nominee must also provide a <strong>notarized copy of the death certificate</strong> of the original shareholder.
          </Typography>
  
          {/* Will Section */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
          When a Will or Probate Exists
          </Typography>
          <Typography variant="body1" paragraph>
            If the deceased had a valid will, the shares are transmitted to the heirs named in the will, upon submission of the necessary documents as prescribed by the company or RTA.
          </Typography>
  
          {/* No Will or Nominee Section */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
          When There is No Will or Nominee
          </Typography>
          <Typography variant="body1" paragraph>
            If the deceased passed away without a will or nominee, the legal heirs must submit the following documents:
          </Typography>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li><Typography variant="body1">Affidavit by the claimant(s)</Typography></li>
            <li><Typography variant="body1">Indemnity Bond</Typography></li>
            <li><Typography variant="body1">Transmission Request Form</Typography></li>
            <li><Typography variant="body1">No Objection Certificate (NOC) from other heirs</Typography></li>
            <li><Typography variant="body1">ISR-4 Form</Typography></li>
            <li><Typography variant="body1">Surety Affidavit</Typography></li>
          </ul>
  
          {/* Jointly Held Account Section */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
          In the Case of Joint Holding
          </Typography>
          <Typography variant="body1" paragraph>
            If the deceased was a part of a <strong>jointly held account</strong>, the securities are transmitted to the surviving account holder(s). The surviving holders must:
          </Typography>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li><Typography variant="body1">Submit a <strong>Transmission Request Form (TRF)</strong> and a <strong>notarized copy of the death certificate</strong>.</Typography></li>
            <li><Typography variant="body1">Open a separate <strong>Demat account</strong> with the same sequence of names as the original joint account, if required.</Typography></li>
          </ul>
        </Box>
      </Box>
    </div>
  );
};

export default TransmissionShares;
